module.exports = __webpack_public_path__ + "img/down_xianlai3.8adad1ef.png";